// 动态路由列表
// about属性为当前路由相关非字(children)路由(动态添加路由需提取添加)
const routers = [
  // 右侧内容路由(包含左菜单。PS:为主目录/下的children子路由)
  // 企业后台
  {
    path: 'dataInsert',
    name: 'dataInsert',
    meta: {
      title: '数据录入',
      needLogin: true,
    },
    component: () => import('@/views/dataInsert/index'),
  },
  {
    path: 'adminSms',
    name: 'adminSms',
    meta: {
      title: '短信列表',
      needLogin: true,
    },
    component: () => import('@/views/admin/sms'),
  },
  {
    path: 'mainHistoryComplex',
    name: 'mainHistoryComplex',
    meta: {
      title: '歷史記錄',
      needLogin: true,
    },
    component: () => import('@/views/main/historyComplex/index'),
  },
  {
    path: 'dataUpdate',
    name: 'dataUpdate',
    meta: {
      title: '数据修改',
      needLogin: true,
    },
    component: () => import('@/views/dataUpdate/index'),
  },
  {
    path: 'reportPrint',
    name: 'reportPrint',
    meta: {
      title: '报告打印',
      needLogin: true,
    },
    component: () => import('@/views/reportPrint/index'),
    about: [
      {
        //报告打印 - 查看报告
        path: '/reportPrint/lookReport',
        name: 'lookReport',
        meta: {
          title: '查看报告',
          needLogin: true, //是否需要登录才能进入
        },
        component: () => import('@/views/reportPrint/lookReport'),
      },
      {
        //报告打印 - 打印模板
        path: '/reportPrint/printTemplate',
        name: 'printTemplate',
        meta: {
          title: '报告打印',
          needLogin: true, //是否需要登录才能进入
        },
        component: () => import('@/views/reportPrint/printTemplate'),
      },
      {
        //报告打印 - 打印模板
        path: '/reportPrint/printTemplate1',
        name: 'printTemplate1',
        meta: {
          title: '报告打印',
          needLogin: true, //是否需要登录才能进入
        },
        component: () => import('@/views/reportPrint/printTemplate1'),
      },
    ],
  },
  {
    path: 'reportBatch',
    name: 'reportBatch',
    meta: {
      title: '批量导出/打印',
      needLogin: true,
    },
    component: () => import('@/views/reportBatch/index'),
  },
  {
    path: 'history',
    name: 'history',
    meta: {
      title: '历史记录',
      needLogin: true,
    },
    component: () => import('@/views/history/index'),
  },

  // 母婴
  {
    path: 'muyingSbpOpen',
    name: 'muyingSbpOpen',
    meta: {
      title: '套餐开通',
      needLogin: true,
    },
    component: () => import('@/views/muying/sbpOpen/index'),
  },
  {
    path: 'muyingDataInsert',
    name: 'muyingDataInsert',
    meta: {
      title: '数据录入',
      needLogin: true,
    },
    component: () => import('@/views/muying/dataInsert/index'),
  },
  {
    path: 'muyingDataUpdate',
    name: 'muyingDataUpdate',
    meta: {
      title: '数据修改',
      needLogin: true,
    },
    component: () => import('@/views/muying/dataUpdate/index'),
  },
  {
    path: 'muyingReportPrint',
    name: 'muyingReportPrint',
    meta: {
      title: '报告打印',
      needLogin: true,
    },
    component: () => import('@/views/muying/reportPrint/index'),
  },
  {
    path: 'muyingHistory',
    name: 'muyingHistory',
    meta: {
      title: '历史记录',
      needLogin: true,
    },
    component: () => import('@/views/muying/history/index'),
  },

  // 大陆体检后台
  {
    path: 'mainDataInsert',
    name: 'mainDataInsert',
    meta: {
      title: '数据录入',
      needLogin: true,
    },
    component: () => import('@/views/main/dataInsert/index'),
  },
  {
    path: 'mainReportPrint',
    name: 'mainReportPrint',
    meta: {
      title: '报告打印',
      needLogin: true,
    },
    component: () => import('@/views/main/reportPrint/index'),
  },
  {
    path: 'mainOrderInfo',
    name: 'mainOrderInfo',
    meta: {
      title: '预约信息调取',
      needLogin: true,
    },
    component: () => import('@/views/main/mainOrderInfo/index'),
  },
  {
    path: 'mainGiftCard',
    name: 'mainGiftCard',
    meta: {
      title: '礼品卡',
      needLogin: true,
    },
    component: () => import('@/views/main/giftCard/index'),
  },
  {
    path: 'mainGiftCardSales',
    name: 'mainGiftCardSales',
    meta: {
      title: '销售统计',
      needLogin: true,
    },
    component: () => import('@/views/main/giftCard/sales'),
  },
  {
    path: 'mainGiftTest',
    name: 'mainGiftTest',
    meta: {
      title: '礼品卡',
      needLogin: true,
    },
    component: () => import('@/views/main/giftCard/test'),
  },
  {
    path: 'mainArticle',
    name: 'mainArticle',
    meta: {
      title: '文章列表',
      needLogin: true,
    },
    component: () => import('@/views/main/article/index'),
  },
  {
    path: 'mainArticleDetail',
    name: 'mainArticleDetail',
    meta: {
      title: '文章编辑',
      needLogin: true,
    },
    component: () => import('@/views/main/article/detail'),
  },
  {
    path: 'mainOpen',
    name: 'mainOpen',
    meta: {
      title: '套餐开通',
      needLogin: true,
    },
    component: () => import('@/views/main/open/index'),
  },
  {
    path: 'mainOpenNew',
    name: 'mainOpenNew',
    meta: {
      title: '套餐开通',
      needLogin: true,
    },
    component: () => import('@/views/main/openNew'),
  },
  {
    path: 'mainOpenComplex',
    name: 'mainOpenComplex',
    meta: {
      title: '套餐開通',
      needLogin: true,
    },
    component: () => import('@/views/main/openComplex/index'),
  },
  {
    path: 'mainInsert',
    name: 'mainInsert',
    meta: {
      title: '数据修改',
      needLogin: true,
    },
    component: () => import('@/views/main/mainInsert/index'),
  },
  {
    path: 'mainDataUpdate',
    name: 'mainDataUpdate',
    meta: {
      title: '数据修改',
      needLogin: true,
    },
    component: () => import('@/views/main/mainDataUpdate/index'),
  },
  {
    path: 'mainHistory',
    name: 'mainHistory',
    meta: {
      title: '历史记录',
      needLogin: true,
    },
    component: () => import('@/views/main/history/index'),
  },

  {
    path: 'mainAppoint',
    name: 'mainAppoint',
    meta: {
      title: '预约信息调取',
      needLogin: true,
    },
    component: () => import('@/views/main/appoint/index'),
  },
  {
    path: 'mainPrintDowload',
    name: 'mainPrintDowload',
    meta: {
      title: '报告下载',
      needLogin: true,
    },
    component: () => import('@/views/main/printDowload/index'),
  },
  {
    path: 'mainPrintDowloadComplex',
    name: 'mainPrintDowloadComplex',
    meta: {
      title: '報告下載',
      needLogin: true,
    },
    component: () => import('@/views/main/printDowloadComplex/index'),
  },
  {
    path: 'mainStatistics',
    name: 'mainStatistics',
    meta: {
      title: '数据统计',
      needLogin: true,
    },
    component: () => import('@/views/main/statistics/index'),
  },
  //消息通知
  {
    path: 'mainInfoNews',
    name: 'mainInfoNews',
    meta: {
      title: '消息通知',
      needLogin: true,
    },
    component: () => import('@/views/main/information/index'),
  },
  //api统计
  {
    path: 'mainAPI',
    name: 'mainAPI',
    meta: {
      title: 'API统计',
      needLogin: true,
    },
    component: () => import('@/views/main/mainAPI/index'),
  },
  //优惠码管理
  {
    path: 'mainDiscount',
    name: 'mainDiscount',
    meta: {
      title: '优惠码管理',
      needLogin: true,
    },
    component: () => import('@/views/main/discount/index'),
  },
  //优惠码管理  记录
  {
    path: 'mainOrder',
    name: 'mainOrder',
    meta: {
      title: '订单列表',
      needLogin: true,
    },
    component: () => import('@/views/main/order/index'),
  },
  //套餐管理
  {
    path: 'mainPackage',
    name: 'mainPackage',
    meta: {
      title: '商品管理',
      needLogin: true,
    },
    component: () => import('@/views/main/packageinfo/index'),
  },
  //套餐管理
  {
    path: 'mainGoodsAi',
    name: 'mainGoodsAi',
    meta: {
      title: 'ai套餐',
      needLogin: true,
    },
    component: () => import('@/views/main/goodsai/index'),
  },
  // 账号管理
  {
    path: 'adminAccount',
    name: 'adminAccount',
    meta: {
      title: '账号管理',
      // needLogin: true //是否需要登录才能进入
    },
    component: () => import('@/views/admin/account/index'),
  },
  // 角色管理
  {
    path: 'adminRole',
    name: 'adminRole',
    meta: {
      title: '角色管理',
      // needLogin: true //是否需要登录才能进入
    },
    component: () => import('@/views/admin/role/index'),
  },
  // 系统设置
  {
    path: 'adminSetting',
    name: 'adminSetting',
    meta: {
      title: '系统设置',
      // needLogin: true //是否需要登录才能进入
    },
    component: () => import('@/views/admin/setting/index'),
  },
  // 菜单管理
  {
    path: 'adminMenu',
    name: 'adminMenu',
    meta: {
      title: '菜单管理',
      // needLogin: true //是否需要登录才能进入
    },
    component: () => import('@/views/admin/menu/index'),
  },
  //企业管理
  {
    path: 'adminEnterprise',
    name: 'adminEnterprise',
    meta: {
      title: '企业管理',
      // needLogin: true //是否需要登录才能进入
    },
    component: () => import('@/views/admin/enterprise/index'),
  },
  // 企业统计  爱汇海创
  {
    path: 'adminCompanyAihui',
    name: 'adminCompanyAihui',
    meta: {
      title: '企业管理',
      needLogin: true, //是否需要登录才能进入
    },
    component: () => import('@/views/company/aihui/index'),
  },
  {
    path: 'adminCompanyAihuiList',
    name: 'adminCompanyAihuiList',
    meta: {
      title: '历史记录',
      needLogin: true, //是否需要登录才能进入
    },
    component: () => import('@/views/company/aihui/list'),
  },
  // 企业统计 康析
  {
    path: 'adminCompanyKangxi',
    name: 'adminCompanyKangxi',
    meta: {
      title: '企业管理',
      needLogin: true, //是否需要登录才能进入
    },
    component: () => import('@/views/company/kangxi/index'),
  },
  {
    path: 'adminCompanyKangxiList',
    name: 'adminCompanyKangxiList',
    meta: {
      title: '历史记录',
      needLogin: true, //是否需要登录才能进入
    },
    component: () => import('@/views/company/kangxi/list'),
  },
  {
    path: 'admintInvoice',
    name: 'admintInvoice',
    meta: {
      title: '发票管理',
      needLogin: true, //是否需要登录才能进入
    },
    component: () => import('@/views/invoice/index'),
  },
  {
    path: 'doctorList',
    name: 'doctorList',
    meta: {
      title: '待处理订单',
      needLogin: true, //是否需要登录才能进入
    },
    component: () => import('@/views/doctor/index'),
  },
  {
    path: 'doctorUpdate',
    name: 'doctorUpdate',
    meta: {
      title: '数据修改',
      needLogin: true, //是否需要登录才能进入
    },
    component: () => import('@/views/doctor/update'),
  },
  {
    path: 'doctorHistory',
    name: 'doctorHistory',
    meta: {
      title: '历史记录',
      needLogin: true, //是否需要登录才能进入
    },
    component: () => import('@/views/doctor/history'),
  },
  {
    path: 'doctorDownlist',
    name: 'doctorDownlist',
    meta: {
      title: '报告下载',
      needLogin: true, //是否需要登录才能进入
    },
    component: () => import('@/views/doctor/downlist'),
  },
  {
    path: 'sanya',
    name: 'sanya',
    meta: {
      title: '健康三亚',
      needLogin: true, //是否需要登录才能进入
    },
    component: () => import('@/views/sanya/index'),
  },
  {
    path: 'sanyaAdd',
    name: 'sanyaAdd',
    meta: {
      title: '健康三亚',
      needLogin: true, //是否需要登录才能进入
    },
    component: () => import('@/views/sanya/add'),
  },
  {
    path: 'entGagc',
    name: 'entGagc',
    meta: {
      title: '国安广传',
      needLogin: true, //是否需要登录才能进入
    },
    component: () => import('@/views/enterprise/gagc'),
  },
  {
    path: 'mainScience',
    name: 'mainScience',
    meta: {
      title: '常见问题',
      needLogin: true,
    },
    component: () => import('@/views/main/science/index'),
  },
  {
    path: 'mainScienceDetail',
    name: 'mainScienceDetail',
    meta: {
      title: '问题编辑',
      needLogin: true,
    },
    component: () => import('@/views/main/science/detail'),
  },
  {
    path: 'mainFeedback',
    name: 'mainFeedback',
    meta: {
      title: '意见反馈',
      needLogin: true,
    },
    component: () => import('@/views/main/feedback/index'),
  },
  {
    path: 'mainUserList',
    name: 'mainUserList',
    meta: {
      title: '用户列表',
      needLogin: true,
    },
    component: () => import('@/views/main/userList/list'),
  },
  {
    path: 'mainUserCharts',
    name: 'mainUserCharts',
    meta: {
      title: '用户统计',
      needLogin: true,
    },
    component: () => import('@/views/main/userList/charts'),
  },
  {
    path: 'mainOrderCharts',
    name: 'mainOrderCharts',
    meta: {
      title: '订单统计',
      needLogin: true,
    },
    component: () => import('@/views/main/order/charts'),
  },
  {
    path: 'gpt',
    name: 'gpt',
    meta: {
      title: '米因AI',
      needLogin: true,
    },
    component: () => import('@/views/gpt/gpt'),
  },
  {
    path: 'sxList',
    name: 'sxList',
    meta: {
      title: '闪休',
      needLogin: true,
    },
    component: () => import('@/views/shanxiu/list'),
  },
  {
    path: 'sxOrder',
    name: 'sxOrder',
    meta: {
      title: '闪休',
      needLogin: true,
    },
    component: () => import('@/views/shanxiu/order'),
  },
  {
    path: 'sxUser',
    name: 'sxUser',
    meta: {
      title: '闪休',
      needLogin: true,
    },
    component: () => import('@/views/shanxiu/user'),
  },
  {
    path: 'sxDiscount',
    name: 'sxDiscount',
    meta: {
      title: '闪休',
      needLogin: true,
    },
    component: () => import('@/views/shanxiu/discount'),
  },
  {
    path: 'archives',
    name: 'archives',
    meta: {
      title: 'AI银发健康评估服务',
      needLogin: true,
    },
    component: () => import('@/views/archives/index'),
  },
  {
    path: 'banner',
    name: 'banner',
    meta: {
      title: '轮播图管理',
      needLogin: true,
    },
    component: () => import('@/views/banner/index.vue'),
  },
] // 所有路由列表

export default routers
